import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_PAYROLL_TYPES_REQUEST = "GET_PAYROLL_TYPES_REQUEST";
export const GET_PAYROLL_TYPES_SUCCESS = "GET_PAYROLL_TYPES_SUCCESS";
export const GET_PAYROLL_TYPES_ERROR = "GET_PAYROLL_TYPES_ERROR";

//* ACTIONS ------------------------------------------------
export const getPayrollTypesRequest = (payload = {}, callback) => ({
  type: GET_PAYROLL_TYPES_REQUEST,
  payload,
  callback,
});

export const getPayrollTypesSuccess = (data) => ({
  type: GET_PAYROLL_TYPES_SUCCESS,
  payload: data,
});

export const getPayrollTypesError = (error) => ({
  type: GET_PAYROLL_TYPES_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getPayrollTypesServiceRequest = async (params = {}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/payrolls/types`, options);
};
